
import ArrowSquareRight from "../../../assets/filled/ArrowSquareRight.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ArrowSquareRightIcon({ className, dataTestid = "ArrowSquareRightIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ArrowSquareRight data-testid={dataTestid} className={classes} {...rest} />
  );
}
